
import { Link } from 'react-router-dom';

interface NavItem {
  name: string;
  href: string;
  isExternal: boolean;
}

interface DesktopNavProps {
  navigation: NavItem[];
}

export const DesktopNav = ({ navigation }: DesktopNavProps) => (
  <nav className="flex items-center justify-center space-x-1">
    {navigation.map((item) => (
      item.isExternal ? (
        <a
          key={item.name}
          href={item.href}
          target="_blank"
          rel="noopener noreferrer"
          className="relative group px-4 py-2 text-gray-700 hover:text-blue-600 font-medium text-sm lg:text-base transition-all duration-300 rounded-xl hover:bg-blue-50/50 border border-transparent hover:border-blue-200/30"
        >
          <span className="relative z-10">{item.name}</span>
          
          {/* Hover background gradient */}
          <div className="absolute inset-0 bg-gradient-to-r from-blue-500/5 to-purple-500/5 rounded-xl opacity-0 group-hover:opacity-100 transition-all duration-300 scale-95 group-hover:scale-100"></div>
          
          {/* Bottom accent line */}
          <span className="absolute bottom-1 left-1/2 transform -translate-x-1/2 w-0 h-0.5 bg-gradient-to-r from-blue-500 to-purple-600 group-hover:w-8 transition-all duration-300 rounded-full"></span>
        </a>
      ) : (
        <Link
          key={item.name}
          to={item.href}
          className="relative group px-4 py-2 text-gray-700 hover:text-blue-600 font-medium text-sm lg:text-base transition-all duration-300 rounded-xl hover:bg-blue-50/50 border border-transparent hover:border-blue-200/30"
        >
          <span className="relative z-10">{item.name}</span>
          
          {/* Hover background gradient */}
          <div className="absolute inset-0 bg-gradient-to-r from-blue-500/5 to-purple-500/5 rounded-xl opacity-0 group-hover:opacity-100 transition-all duration-300 scale-95 group-hover:scale-100"></div>
          
          {/* Bottom accent line */}
          <span className="absolute bottom-1 left-1/2 transform -translate-x-1/2 w-0 h-0.5 bg-gradient-to-r from-blue-500 to-purple-600 group-hover:w-8 transition-all duration-300 rounded-full"></span>
        </Link>
      )
    ))}
  </nav>
);
